import {LABEL_FACTORY_LIST_GET , LABEL_FACTORY_LIST_SUCCESS,LABEL_FACTORY_LIST_FAILURE } from './actions';

const initialState = {
    order: {},
    request:{},
}

export function LabelFactoryListReducer(state = initialState, action) {
    
    if(action.type === LABEL_FACTORY_LIST_GET) {
        return state;
    }
    if(action.type === LABEL_FACTORY_LIST_SUCCESS) {
        return {
            ...state,
            order: {
                isLoaded: true,
                data: action.payload.res,
                message: 'Success'
            },
            request:action.payload.request
        }
    }
    if(action.type === LABEL_FACTORY_LIST_FAILURE) {
        return {
            ...state,
            order: {
                data: [],
                message: action.payload.message
            },
            request:action.payload.request
        }
    }
    return state;
}

